import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=00f6b9dd&scoped=true"
import script from "./strategy.vue?vue&type=script&lang=js"
export * from "./strategy.vue?vue&type=script&lang=js"
import style0 from "./strategy.vue?vue&type=style&index=0&id=00f6b9dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6b9dd",
  null
  
)

export default component.exports